import * as zod from 'zod';

import { TCPOffsetOptionStrict } from '@sb/motion-planning';
import { PayloadState } from '@sb/routine-runner/types/PayloadState';

export const EnableGripperArguments = zod.object({
  deviceID: zod.string().optional(),
  payload: PayloadState.nullable().default(null),
  waitForGripperToInitialize: zod.boolean().default(false),
  setActiveTooltip: zod.boolean().default(false),
  // Strict: a persisted intent field must fail loudly on a name it cannot
  // mean, never coerce to the wrist and silently change which tool moves.
  activeTooltipOption: TCPOffsetOptionStrict.optional(),
});

export type EnableGripperArguments = zod.infer<typeof EnableGripperArguments>;
